"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.indicatorSchema = void 0;
var constants_1 = require("../../constants");
exports.indicatorSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        claimProcessingUnitTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be an string or null',
        },
        claimReceivedDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            format: 'date',
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        eddFemsiFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        editsAndAllowancesFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        enhancedAcppFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        gvsPviiFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        manualReviewRequiredFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        manualReviewRequiredReasonTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.ManualReviewRequiredReasonTypeCode), [null]),
            errorMessage: 'Should equate to a valid ManualReviewRequiredReasonTypeCode Enum value or null',
        },
        notepadCommentFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        otherManualReviewRequiredReasonDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        paymentCount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        rffiFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        underwritingInformationReceivedDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        underwritingInformationRequestedDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        underwritingReviewEndDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        underwritingReviewFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        underwritingReviewStartDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
    },
    allOf: [
        {
            if: {
                required: ['manualReviewRequiredFlag'],
                properties: {
                    manualReviewRequiredFlag: {
                        const: true,
                    },
                },
            },
            then: {
                required: ['manualReviewRequiredReasonTypeCode'],
                properties: {
                    manualReviewRequiredReasonTypeCode: {
                        type: 'string',
                        enum: __spreadArrays(Object.values(constants_1.ManualReviewRequiredReasonTypeCode)),
                        errorMessage: 'manualReviewRequiredReasonTypeCode is required if manualReviewRequiredFlag is true',
                    },
                },
            },
        },
        {
            if: {
                required: ['manualReviewRequiredReasonTypeCode'],
                properties: {
                    manualReviewRequiredReasonTypeCode: {
                        const: constants_1.ManualReviewRequiredReasonTypeCode.Other,
                    },
                },
            },
            then: {
                required: ['otherManualReviewRequiredReasonDescription'],
                properties: {
                    otherManualReviewRequiredReasonDescription: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 100,
                        errorMessage: 'otherManualReviewRequiredReasonDescription is required if manualReviewRequiredReasonTypeCode is Other',
                    },
                },
            },
        },
        {
            if: {
                required: ['manualReviewRequiredFlag'],
                properties: {
                    manualReviewRequiredFlag: {
                        const: false,
                    },
                },
            },
            then: {
                properties: {
                    manualReviewRequiredReasonTypeCode: {
                        type: 'null',
                        errorMessage: "manualReviewRequiredReasonTypeCode should be null if manualReviewRequiredFlag is false",
                    },
                },
            },
        },
        {
            if: {
                required: ['manualReviewRequiredFlag'],
                properties: {
                    manualReviewRequiredFlag: {
                        const: false,
                    },
                },
            },
            then: {
                properties: {
                    otherManualReviewRequiredReasonDescription: {
                        type: 'null',
                        errorMessage: "otherManualReviewRequiredReasonDescription should be null if manualReviewRequiredFlag is false",
                    },
                },
            },
        },
        {
            if: {
                required: ['manualReviewRequiredReasonTypeCode'],
                properties: {
                    manualReviewRequiredReasonTypeCode: {
                        type: ['string', 'null'],
                        enum: __spreadArrays(Object.values(constants_1.ManualReviewRequiredReasonTypeCode).filter(function (code) {
                            return code !== constants_1.ManualReviewRequiredReasonTypeCode.Other;
                        }), [
                            null,
                        ]),
                    },
                },
            },
            then: {
                properties: {
                    otherManualReviewRequiredReasonDescription: {
                        type: 'null',
                        errorMessage: "otherManualReviewRequiredReasonDescription should be null if manualReviewRequiredReasonTypeCode is not Other",
                    },
                },
            },
        },
    ],
};
